<div class="otp-modal">
	<div class="otp-modal-content">
		<div *ngIf="!store.user().otp.confirmed; else otpConfirmed">
			<div class="otp-modal-header">
				<div class="otp-modal-header-content">
					<div class="otp-modal-title">Turn on 2-Step Verification</div>
					<div class="otp-modal-description">Open an authenticator app and scan the QR code below</div>
				</div>
				<div class="otp-modal-qr-code">
					<qrcode [qrdata]="provisioningQRCode()" [width]="200" [errorCorrectionLevel]="'M'" />
				</div>
				<div class="otp-modal-input-container">
					<div class="otp-modal-description">Enter the authentication code generated by your app</div>
					<form [formGroup]="form">
						<app-apple-input placeholder="Enter Code" formControlName="code" />
						<app-apple-button [disabled]="form.invalid" (click)="verifyOTP()">Continue</app-apple-button>
					</form>
				</div>
				<div class="otp-modal-or">OR ENTER CODE MANUALLY</div>
				<div class="otp-code-value">
					<div class="otp-code-value-item">{{ provisioningCode() }}</div>
				</div>
				<div class="otp-modal-footer">
					<div class="otp-modal-footer-text">
						Don't have an authenticator app?
						<a href="http://docs.barrowscs.com/two-step-verification" target="_blank">Learn More</a>
					</div>
				</div>
			</div>
		</div>
		<ng-template #otpConfirmed>
			<div class="otp-modal-header">
				<div class="otp-modal-header-content">
					<div class="otp-modal-title">Confirm 2-Step Verification</div>
					<div class="otp-modal-description">Enter the code from your authenticator app</div>
				</div>
				<form [formGroup]="form">
					<app-apple-input placeholder="Enter Code" formControlName="code" />
					<app-apple-button [disabled]="form.invalid" (click)="verifyOTP()">Continue</app-apple-button>
				</form>
				<div class="otp-modal-footer">
					<div class="otp-modal-footer-text">
						Lost access to your authenticator app?
						<a href="http://docs.barrowscs.com/two-step-verification" target="_blank">Learn More</a>
					</div>
				</div>
			</div>
		</ng-template>
	</div>
</div>
